import { RouterProvider } from 'react-router-dom';

import { useHtmlLang, useNewRelic } from './hooks';
import { router } from './routes';
import GlobalStyle from './styles/global-styles';

export const App = (): React.JSX.Element => {
  useNewRelic();
  useHtmlLang();

  return (
    <>
      <GlobalStyle />
      <RouterProvider router={router} />
    </>
  );
};
